/**
 * Check if a user's trial has expired
 * @param {Object} user - User object from Cognito
 * @returns {boolean} - True if trial has expired
 */
export const isTrialExpired = (user) => {
  if (!user || !user['custom:created_at']) {
    return false;
  }

  const trialTime = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
  const created_at = Number.parseInt(user['custom:created_at'] || 0);
  const extendedTrialTime =
    Number.parseInt(user['custom:extended_trial_days'] || 0) * 24 * 60 * 60 * 1000;
  const expiryTime = created_at + trialTime + extendedTrialTime;
  const today = new Date().getTime();

  return expiryTime < today;
};

/**
 * Get days remaining in trial
 * @param {Object} user - User object from Cognito
 * @returns {number} - Days remaining (negative if expired)
 */
export const getTrialDaysRemaining = (user) => {
  if (!user || !user['custom:created_at']) {
    return 0;
  }

  const trialTime = 7 * 24 * 60 * 60 * 1000;
  const created_at = Number.parseInt(user['custom:created_at'] || 0);
  const extendedTrialTime =
    Number.parseInt(user['custom:extended_trial_days'] || 0) * 24 * 60 * 60 * 1000;
  const expiryTime = created_at + trialTime + extendedTrialTime;
  const today = new Date().getTime();
  const msRemaining = expiryTime - today;

  return Math.ceil(msRemaining / (24 * 60 * 60 * 1000));
};

/**
 * Check if user has academic approval pending
 * @param {Object} user - User object from Cognito
 * @returns {boolean}
 */
export const hasAcademicPending = (user) => {
  return user?.['custom:academic_pending'] === 'true';
};

/**
 * Check if user has academic approval (pending payment)
 * @param {Object} user - User object from Cognito
 * @returns {boolean}
 */
export const hasAcademicApproved = (user) => {
  return user?.['custom:academic_approved'] === 'true';
};
